import type { OperationPackageInstanceResponse } from '@/features/operation-instances/api';

/** ドメイン反映がなくデータタブを出さない packageType */
const PACKAGES_WITHOUT_DATA_TAB = ['BYODRegistration', 'DeviceArrangement', 'DeviceLending', 'DeviceReturn', 'MailAddressCreation', 'LicenseAssignment', 'InHouseItocApproval'] as const satisfies readonly OperationPackageInstanceResponse['packageType'][];
export function isPackageWithoutDataTab(packageType: OperationPackageInstanceResponse['packageType']): boolean {
  return (PACKAGES_WITHOUT_DATA_TAB as readonly string[]).includes(packageType);
}